<template>
  <div class="diet-content">
    <div class="diet-item" v-for="(item, index) in mealList" :key="index">
      <div class="item-top">
        <div
          class="item-title"
          :style="{ backgroundColor: btnColorList[item.curMeal] }"
        >
          {{ item.name }}
        </div>
        <div class="diet-time" v-if="item.eat_time">
          用餐时间：{{ item.eat_time }}
        </div>
      </div>
      <div class="diet-text">
        <span>{{ item.say_text }}</span>
      </div>
      <div v-if="!item.eat_img.length" class="not-diet">
        没有{{ item.name }}
      </div>
    </div>
    <div class="image-container" v-if="imageList.length">
      <div class="image-list">
        <div class="image-item" v-for="(item, index) in imageList" :key="index">
          <FlagComponent
            class="flg-component"
            :scale="0.7"
            :curMeal="item.type.curMeal"
            :type2="item.type.type2"
            :pType="item.type.p_type"
          ></FlagComponent>
          <img
            class="image"
            :src="
              formatImageUrl(
                item.image + '?x-oss-process=image/resize,w_194/quality,Q_80'
              )
            "
            @click.stop="previewImage(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import FlagComponent from './flag-component.vue'
export default {
  components: {
    FlagComponent
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      nameList: ['早餐', '午餐', '晚餐', '加餐'],
      btnColorList: ['#74d8c8', '#ffb970', '#838aae', '#fa6400'],
      mealList: [],
      imageList: []
    }
  },
  watch: {
    data() {
      this.updateMealList(this.data)
      this.updateImageList(this.data)
    }
  },
  created() {
    this.updateMealList(this.data)
    this.updateImageList(this.data)
  },
  methods: {
    formatImageUrl(imageUrl) {
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    updateImageList(data) {
      let imageList = []
      data.map((item) => {
        let imgs = item.eat_img ? item.eat_img.split(',') : []
        imgs.map((item1) => {
          let obj = {}
          obj.name = this.nameList[item.curMeal]
          obj.type = {
            p_type: 3,
            curMeal: item.curMeal,
            type2: -1
          }
          obj.image = item1
          imageList.push(obj)
        })
      })
      this.imageList = imageList
    },
    updateMealList(data) {
      let mealList = data.map((item) => {
        let obj = {}
        obj.index = item.curMeal
        obj.say_text = item.say_text
        obj.name = this.nameList[item.curMeal]
        obj.curMeal = item.curMeal
        obj.type = {
          p_type: 3,
          curMeal: item.curMeal,
          type2: -1
        }
        obj.eat_img = item.eat_img ? item.eat_img.split(',') : []
        obj.eat_time = item.eat_time.slice(11, 16)
        return obj
      })
      let res = []
      for (let i = 0; i < this.nameList.length; i++) {
        res.push({
          index: i,
          curMeal: i,
          name: this.nameList[i],
          type: {
            p_type: 3,
            curMeal: i,
            type2: -1
          },
          eat_img: [],
          eat_time: ''
        })
      }
      mealList.map((item) => {
        res[item.curMeal < 0 ? 0 : item.curMeal] = item
      })
      this.mealList = res
    },
    previewImage(index) {
      let images = this.imageList.map((item) => {
        return item.image + '?x-oss-process=image/resize,w_750/quality,Q_100'
      })
      ImagePreview({
        images: images,
        startPosition: index
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.diet-content {
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  padding: 15px 16px;
  margin-bottom: 19px;
  box-sizing: border-box;
}
.diet-item {
  overflow: hidden;
  border-radius: 6px;
  background-color: #fff;
  margin-bottom: 10px;
  position: relative;
}
.item-top {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.item-title {
  width: 45px;
  height: 20px;
  background-color: #74d8c8;
  border-radius: 4px;
  line-height: 20px;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}
.flg-component {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1;
}
.image-container {
  width: 100%;
}
.image-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.image-list .image-item {
  position: relative;
  width: 97px;
  height: 97px;
  box-sizing: border-box;
  background-color: #f1f1f1;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
  margin-bottom: 10px;
}
.image-item .image {
  width: 100%;
  height: 100%;
}
.image-list .image-item:nth-child(3n) {
  margin-right: 0;
}
.diet-time {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: 8px;
}
.diet-text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  line-height: 22px;
  color: #000;
}
.not-diet {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 4px;
}
</style>
